import React from 'react';
import { Helmet } from 'react-helmet';
// import { getVerticalFooterData } from './footer-data';
import './footer.css';

function Footer(props) {
  const { vertical, footerLinksHTML } = props;
  let dynamicLink = '';
  if (footerLinksHTML) {
    dynamicLink = footerLinksHTML;
  }
  // else {
  // const popularList = getVerticalFooterData(vertical);
  // dynamic links are explicitly done as string literal to save data size. otherwise we will need to send data to store to support client side rendering
  //   dynamicLink = popularList
  //     .map(
  //       item =>
  //         `<p className="fl width100">
  //       <span className="greyLter ico12 f500 fl padR5">${item.block_title}</span>
  //       ${item.links_data
  //         .map(
  //           element =>
  //             `<a href=${element.link}>
  //           ${element.name} |
  //         </a>`
  //         )
  //         .join('')}
  //     </p>`
  //     )
  //     .join('');
  // }

  return (
    <>
      {/* <Helmet
        link={[
          {
            href: 'https://goibibo.ibcdn.com/styleguide/css/combinedStyles.css',
            rel: 'stylesheet',
            type: 'text/css',
            media: 'all'
          }
        ]}
      /> */}
      <div className="footerBox mobdn posRel">
        <div className="website-badge-Bottom">
          <a className="awsAward" href="https://yourstory.com/aws-mobility/" target="_blank">
            &nbsp;
          </a>
        </div>
        <div className="maxWidth1020 marginAuto">
          <div className="col-md-10 col-sm-12 padB20">
            <ul className="col-md-3 col-sm-3 footerLinks">
              <li className="txtTransUpper greyDr f500 padB10">our products</li>
              <li>
                <a href="/hotels/">Domestic Hotels</a>
              </li>
              <li>
                <a href="/hotels-international/">International Hotels</a>
              </li>
              <li>
                <a href="/flights/">Domestic Flights</a>
              </li>
              <li>
                <a href="/international-flights/">International Flights</a>
              </li>
              <li>
                <a href="/bus/">Bus Booking</a>
              </li>
              <li>
                <a href="/cars/">Cab Booking</a>
              </li>
              <li>
                <a href="/trains/">Train Ticket Booking</a>
              </li>
              <li>
                <a href="/routeplanner/">Route Planner</a>
              </li>
              <li>
                <a href="/destinations/">Destination Planner</a>
              </li>
            </ul>
            <ul className="col-md-3 col-sm-3 footerLinks">
              <li className="txtTransUpper greyDr f500 padB10">Company</li>
              <li>
                <a href="/aboutus/">About Us</a>
              </li>
              <li>
                <a href="/info/terms-of-services/">Terms of Services</a>
              </li>
              <li>
                <a href="/info/user-agreement/">User Agreement</a>
              </li>
              <li>
                <a href="/info/privacy/">Privacy</a>
              </li>
              <li>
                <a href="/support/">Contact Us</a>
              </li>
              <li>
                <a href="/careers/" target="_blank">
                  Careers
                </a>
              </li>
              <li>
                <a href="/info/corporate-social-responsibility/">Corporate Social Responsibility</a>
              </li>
              <li>
                <a href="/mobile/">Goibibo on Mobile</a>
              </li>
              <li>
                <a href="https://www.youtube.com/user/goibibo">Goibibo TV Advertisement</a>
              </li>
              <li>
                <a href="https://tech.goibibo.com/" target="_blank">
                  Technology@Goibibo
                </a>
              </li>
            </ul>
            <ul className="col-md-3 col-sm-3 footerLinks">
              <li className="txtTransUpper greyDr f500 padB10">travel resources</li>
              <li>
                <a href="/bus/bus-routes/">Popular Bus Routes</a>
              </li>
              <li>
                <a href="/trains/check-pnr-status/">Train PNR Status</a>
              </li>
              <li>
                <a href="/cars/airport-cabs/">Airport Cabs</a>
              </li>
              <li>
                <a href="/hotels/india/">Hotels in India</a>
              </li>
              <li>
                <a href="/airlines/">Popular Airlines</a>
              </li>
              <li>
                <a href="/offers/">Goibibo Offers</a>
              </li>
              <li>
                <a href="/airports/">International Airports</a>
              </li>
              <li>
                <a href="/flights/city-to-city-airlines/">City Airline Routes</a>
              </li>
              <li>
                <a href="/destinations/intl/">International Travel Guide</a>
              </li>
            </ul>
            <ul className="col-md-3 col-sm-3 footerLinks">
              <li className="txtTransUpper greyDr f500 padB10">more links</li>
              <li>
                <a href="/flights/cheap-flights/">Cheap Flights</a>{' '}
              </li>
              <li>
                <a href="/trains/check-train-running-status/">Train Running Status</a>
              </li>
              <li>
                <a href="/flight-schedule/">Flight Schedule</a>
              </li>
              <li>
                <a href="/gostays/">Go Stays</a>
              </li>
              <li>
                <a href="/bus/city-buses/">Popular Bus Cities</a>
              </li>
              <li>
                <a href="/airports/airports-in-india/">Airports in India</a>
              </li>
              <li>
                <a href="/hotels/chain/">Popular Hotel Chains</a>
              </li>
              <li>
                <a href="/info/hotels-near-me/">Hotels Near Me</a>
              </li>
            </ul>
          </div>

          <div className="col-md-12 col-sm-12 padTB20 fotDPLink borderTop">
            <div className="width100 fl pDTB20 fotDPLink">
              <div className="width100 fl pDTB20 fotDPLink">
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Popular Flight Sectors</span>
                  <a href="https://www.goibibo.com/flights/mumbai-to-delhi-flights/">
                    Mumbai to Delhi Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/pune-to-delhi-flights/">
                    Pune to Delhi Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/bangalore-to-delhi-flights/">
                    Bangalore to Delhi Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/goa-to-delhi-flights/">
                    Goa to Delhi Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/delhi-to-mumbai-flights/">
                    Delhi to Mumbai Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/ahmedabad-to-mumbai-flights/">
                    Ahmedabad to Mumbai Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/bangalore-to-mumbai-flights/">
                    Bangalore to Mumbai Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/chennai-to-mumbai-flights/">
                    Chennai to Mumbai Flight|
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-bangalore-flights/">
                    Mumbai to Bangalore Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/kolkata-to-bangalore-flights/">
                    Kolkata to Bangalore Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/delhi-to-bangalore-flights/">
                    Delhi to Bangalore Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/pune-to-bangalore-flights/">
                    Pune to Bangalore Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-goa-flights/">
                    Mumbai to Goa Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/pune-to-goa-flights/">
                    Pune to Goa Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/delhi-to-goa-flights/">
                    Delhi to Goa Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/indore-to-goa-flights/">
                    Indore to Goa Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-jaipur-flights/">
                    Mumbai to Jaipur Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/ahmedabad-to-jaipur-flights/">
                    Ahmedabad to Jaipur Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/pune-to-jaipur-flights/">
                    Pune to Jaipur Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/bangalore-to-jaipur-flights/">
                    Bangalore to Jaipur Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-kolkata-flights/">
                    Mumbai to Kolkata Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/hyderabad-to-kolkata-flights/">
                    Hyderabad to Kolkata Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/delhi-to-kolkata-flights/">
                    Delhi to Kolkata Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/bangalore-to-kolkata-flights/">
                    Bangalore to Kolkata Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/ahmedabad-to-mumbai-flights/">
                    Ahmedabad to Mumbai Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/siliguri-to-kolkata-flights/">
                    Bagdogra to Kolkata Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/bangalore-to-udaipur-flights/">
                    Bangalore to Udaipur Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/bhopal-to-bangalore-flights/">
                    Bhopal to Bangalore Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/bhubaneswar-to-mumbai-flights/">
                    Bhubaneshwar to Mumbai Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/chandigarh-to-chennai-flights/">
                    Chandigarh to Chennai Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/chennai-to-jaipur-flights/">
                    Chennai to Jaipur Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/delhi-to-vadodara-flights/">
                    Delhi to Vadodara Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/goa-to-pune-flights/">
                    Goa to Pune Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/hyderabad-to-coimbatore-flights/">
                    Hyderabad to Coimbatore Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/hyderabad-to-patna-flights/">
                    Hyderabad to Patna Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/jaipur-to-bangalore-flights/">
                    Jaipur to Bangalore Flight |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Top Routes</span>
                  <a href="https://www.goibibo.com/flights/delhi-to-pune-flights/">
                    Delhi to Pune Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/kolkata-to-pune-flights/">
                    Kolkata to Pune Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/nagpur-to-pune-flights/">
                    Nagpur to Pune Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/bangalore-to-pune-flights/">
                    Bangalore to Pune Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-hyderabad-flights/">
                    Mumbai to Hyderabad flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/delhi-to-hyderabad-flights/">
                    Delhi to Hyderabad flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/kolkata-to-hyderabad-flights/">
                    Kolkata to Hyderabad flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/bangalore-to-hyderabad-flights/">
                    Bangalore to Hyderabad flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-chennai-flights/">
                    Mumbai to Chennai Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/hyderabad-to-chennai-flights/">
                    Hyderabad to Chennai Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/delhi-to-chennai-flights/">
                    Delhi to Chennai Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/coimbatore-to-chennai-flights/">
                    Coimbatore to Chennai Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/delhi-to-ahmedabad-flights/">
                    Delhi to Ahmedabad Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/mumbai-to-ahmedabad-flights/">
                    Mumbai to Ahmedabad Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/bangalore-to-ahmedabad-flights/">
                    Bangalore to Ahmedabad Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/pune-to-ahmedabad-flights/">
                    Pune to Ahmedabad Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/delhi-to-patna-flights/">
                    Delhi to Patna Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/bangalore-to-patna-flights/">
                    Bangalore to Patna Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-patna-flights/">
                    Mumbai to Patna Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/kolkata-to-patna-flights/">
                    Kolkata to Patna Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/delhi-to-lucknow-flights/">
                    Delhi to Lucknow Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/mumbai-to-lucknow-flights/">
                    Mumbai to Lucknow Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/bangalore-to-lucknow-flights/">
                    Bangalore to Lucknow Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/pune-to-lucknow-flights/">
                    Pune to Lucknow Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/lucknow-to-kolkata-flights/">
                    Lucknow to Kolkata Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/mangalore-to-bangalore-flights/">
                    Mangalore to Bangalore Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-coimbatore-flights/">
                    Mumbai to Coimbatore Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/mumbai-to-indore-flights/">
                    Mumbai to Indore Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-rajkot-flights/">
                    Mumbai to Rajkot Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/mumbai-to-surat-flights/">
                    Mumbai to Surat Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-vijayawada-flights/">
                    Mumbai to Vijaywada Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/pune-to-chennai-flights/">
                    Pune to Chennai Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/bhubaneswar-to-kolkata-flights/">
                    Bhubaneshwar to Kolkata Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/delhi-to-kozhikode-flights/">
                    Delhi to Kozhikode Flight |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/mumbai-to-jodhpur-flights/">
                    Mumbai to Jodhpur Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/ranchi-to-mumbai-flights/">
                    Ranchi to Mumbai Flight |
                  </a>
                  <a href="https://www.goibibo.com/flights/vadodara-to-chennai-flights/">
                    Vadodara to Chennai Flight |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Trending Hotel Cities</span>
                  <a href="https://www.goibibo.com/hotels/hotels-in-goa/">Hotels in Goa |</a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-delhi/">Hotels in Delhi |</a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-bangalore/">
                    Hotels in Bangalore |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-mumbai/">Hotels in Mumbai |</a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-jaipur/">
                    Hotels in Jaipur |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-chennai/">
                    Hotels in Chennai |
                  </a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-kolkata/">
                    Hotels in Kolkata |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-ernakulam/">
                    Hotels in Ernakulam |
                  </a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-manali/">Hotels in Manali |</a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-hyderabad/">
                    Hotels in Hyderabad |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">
                    Trending International Hotel Cities
                  </span>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-bali-ct/">Bali Hotels |</a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-dubai-ct/">
                    Dubai Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-singapore-ct/">
                    Singapore Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-kuala-lumpur-ct/">
                    Kuala Lumpur Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-thimphu-ct/">
                    Thimphu Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-bangkok-ct/">
                    Bangkok Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-pattaya-ct/">
                    Pattaya Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-kathmandu-ct/">
                    Kathmandu Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-phuket-ct/">
                    Phuket Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-pokhara-ct/">
                    Pokhara Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-maldives-ct/">
                    Maldives Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-hong-kong-ct/">
                    Hong Kong Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-paris-ct/">
                    Paris Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-london-ct/">
                    London Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-goa/">Hotels in Goa |</a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-delhi/">
                    Hotels in Delhi |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-bangalore/">
                    Hotels in Bangalore |
                  </a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-mumbai/">Hotels in Mumbai |</a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-jaipur/">Hotels in Jaipur |</a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-chennai/">
                    Hotels in Chennai |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-kolkata/">
                    Hotels in Kolkata |
                  </a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-ernakulam/">
                    Hotels in Ernakulam |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-manali/">Hotels in Manali |</a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-hyderabad/">
                    Hotels in Hyderabad |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">
                    Trending International Hotel Cities
                  </span>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-bali-ct/">Bali Hotels |</a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-dubai-ct/">
                    Dubai Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-singapore-ct/">
                    Singapore Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-kuala-lumpur-ct/">
                    Kuala Lumpur Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-thimphu-ct/">
                    Thimphu Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-bangkok-ct/">
                    Bangkok Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-pattaya-ct/">
                    Pattaya Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-kathmandu-ct/">
                    Kathmandu Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-phuket-ct/">
                    Phuket Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-pokhara-ct/">
                    Pokhara Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-maldives-ct/">
                    Maldives Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-hong-kong-ct/">
                    Hong Kong Hotels |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-paris-ct/">
                    Paris Hotels |
                  </a>
                  <a href="https://www.goibibo.com/hotels/intl-hotels-in-london-ct/">
                    London Hotels |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">
                    Popular Bus Routes and Operators
                  </span>
                  <a href="https://www.goibibo.com/bus/amritsar-to-chandigarh-bus-tickets/">
                    Amritsar Chandigarh buses |
                  </a>
                  <a href="https://www.goibibo.com/bus/bangalore-to-goa-bus-tickets/">
                    Bangalore Goa buses |
                  </a>{' '}
                  <a href="https://www.goibibo.com/bus/delhi-to-manali-bus-tickets/">
                    Delhi Manali buses |
                  </a>
                  <a href="https://www.goibibo.com/bus/gandhinagar-to-rajkot-bus-tickets/">
                    Gandhinagar Rajkot buses |
                  </a>{' '}
                  <a href="https://www.goibibo.com/bus/hyderabad-to-bangalore-bus-tickets/">
                    Hyderabad Bangalore buses |
                  </a>
                  <a href="https://www.goibibo.com/bus/kolkata-to-digha-bus-tickets/">
                    Kolkata Digha buses |
                  </a>{' '}
                  <a href="https://www.goibibo.com/bus/jaipur-to-delhi-bus-tickets/">
                    Jaipur Delhi buses |
                  </a>
                  <a href="https://www.goibibo.com/bus/bangalore-to-chennai-bus-tickets/">
                    Bangalore Chennai buses |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Top Searched Routes</span>
                  <a href="//www.goibibo.com/routeplanner/delhi-munnar/">Delhi to Munnar |</a>{' '}
                  <a href="//www.goibibo.com/routeplanner/delhi-shirdi/">Delhi to Shirdi |</a>
                  <a href="//www.goibibo.com/routeplanner/mumbai-katra/">Mumbai to Katra |</a>{' '}
                  <a href="//www.goibibo.com/routeplanner/hyderabad-ajmer/">Hyderabad to Ajmer |</a>
                  <a href="//www.goibibo.com/routeplanner/chennai-darjeeling/">
                    Chennai to Darjeeling |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Popular Train Sectors</span>
                  <a href="https://www.goibibo.com/trains/mumbai-to-pune-trains/">
                    Mumbai to Pune Trains |
                  </a>
                  <a href="https://www.goibibo.com/trains/delhi-to-agra-trains/">
                    Delhi To Agra Trains |
                  </a>{' '}
                  <a href="https://www.goibibo.com/trains/delhi-to-jaipur-trains/">
                    Delhi To Jaipur Trains |
                  </a>
                  <a href="https://www.goibibo.com/trains/pune-to-mumbai-trains/">
                    Pune To Mumbai Trains |
                  </a>{' '}
                  <a href="https://www.goibibo.com/trains/bangalore-to-chennai-trains/">
                    Bangalore To Chennai Trains |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Popular Flight Cities</span>
                  <a href="https://www.goibibo.com/flights/flights-to-delhi/">Flights to Delhi |</a>
                  <a href="https://www.goibibo.com/flights/flights-from-delhi/">
                    Flights from Delhi |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/flights-to-bangalore/">
                    Flights to Bangalore |
                  </a>
                  <a href="https://www.goibibo.com/flights/flights-from-bangalore/">
                    Flights from Bangalore |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/flights-to-hyderabad/">
                    Flights to Hyderabad |
                  </a>
                  <a href="https://www.goibibo.com/flights/flights-from-hyderabad/">
                    Flights from Hyderabad |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/flights-to-goa/">Flights to Goa |</a>
                  <a href="https://www.goibibo.com/flights/flights-from-goa/">
                    Flights from Goa |
                  </a>{' '}
                  <a href="https://www.goibibo.com/flights/flights-to-mumbai/">
                    Flights to Mumbai |
                  </a>
                  <a href="https://www.goibibo.com/flights/flights-from-mumbai/">
                    Flights from Mumbai |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Popular Car Routes</span>
                  <a href="https://www.goibibo.com/cars/mumbai-to-goa-cars/">
                    Mumbai to Goa cars |
                  </a>
                  <a href="https://www.goibibo.com/cars/delhi-to-jaipur-cars/">
                    Delhi to Jaipur cars |
                  </a>{' '}
                  <a href="https://www.goibibo.com/cars/bangalore-to-hyderabad-cars/">
                    Bangalore to Hyderabad cars |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Trending Destinations</span>
                  <a href="https://www.goibibo.com/destinations/goa/">Goa |</a>{' '}
                  <a href="https://www.goibibo.com/destinations/manali/">Manali |</a>
                  <a href="https://www.goibibo.com/destinations/shimla/">Shimla |</a>{' '}
                  <a href="https://www.goibibo.com/destinations/ooty/">Ooty |</a>{' '}
                  <a href="https://www.goibibo.com/destinations/darjeeling/">Darjeeling |</a>
                  <a href="https://www.goibibo.com/destinations/munnar/">Munnar |</a>{' '}
                  <a href="https://www.goibibo.com/destinations/gangtok/">Gangtok |</a>{' '}
                  <a href="https://www.goibibo.com/destinations/mysore/">Mysore |</a>
                  <a href="https://www.goibibo.com/destinations/jaipur/">Jaipur |</a>{' '}
                  <a href="https://www.goibibo.com/destinations/agra/">Agra |</a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Trending Pages</span>
                  <a href="https://www.goibibo.com/info/hotels-near-me/">Hotels near me |</a>{' '}
                  <a href="https://www.goibibo.com/flights/cheap-flights/">Cheap flights |</a>
                  <a href="https://www.goibibo.com/hotels/india/">Indian Hotels |</a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-kerala/">Hotels in Kerala |</a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-rajasthan/">
                    Hotels in Rajasthan |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-sikkim/">Hotels in Sikkim |</a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-goa/cs-1071-cl/">
                    Top Rated Hotels in Goa |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-delhi/cs-1071-cl/">
                    Top Rated Hotels in Delhi |
                  </a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-jaipur/cs-1071-cl/">
                    Top Rated Hotels in Jaipur |
                  </a>{' '}
                  <a href="https://www.goibibo.com/hotels/hotels-in-digha-ct/">Digha Hotels |</a>
                  <a href="https://www.goibibo.com/hotels/hotels-in-gurgaon-ct/">
                    Gurgaon Hotels |
                  </a>
                </p>
                <p className="fl width100">
                  <span className="greyLter ico12 fb fl padR5">Popular Cab Cities</span>
                  <a href="https://www.goibibo.com/cars/cabs-to-jaipur/">Cabs to Jaipur |</a>{' '}
                  <a href="https://www.goibibo.com/cars/cabs-from-delhi/">Cabs from Delhi |</a>
                  <a href="https://www.goibibo.com/cars/cabs-from-bangalore/">
                    Cabs from Bangalore |
                  </a>{' '}
                  <a href="https://www.goibibo.com/cars/cabs-to-agra/">Cabs to Agra |</a>
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-sm-12 col-xs-12 footerAppLinks">
            <div className="col-md-2 col-sm-3">
              <p className="ico14 f500">Follow Us</p>
              <div className="padT10">
                <a
                  target="_blank"
                  href="http://www.facebook.com/goibibo"
                  className="fl padR10"
                  title="facebook"
                >
                  <i className="ico24 lh1-2  greyLt icon-facebook"></i>
                </a>
                <a
                  target="_blank"
                  href="http://twitter.com/goibibo"
                  className="fl padR10"
                  title="Twitter"
                >
                  <i className="ico26 lh1-2  greyLt icon-twitter"></i>
                </a>
                <a
                  target="_blank"
                  href="http://www.youtube.com/user/goibibo"
                  className="fl padR10"
                  title="youtube"
                >
                  <i className="ico28 greyLt icon-youtube"></i>
                </a>
                <a
                  target="_blank"
                  href="https://plus.google.com/+goibibo/"
                  className="fl"
                  title="Google Plus"
                >
                  <span className="hd_vs fr_gplus margin0">&nbsp;</span>
                </a>
              </div>
            </div>
            <div className="col-md-5 col-sm-6">
              <p className="ico14 f500">Book Tickets faster. Download our mobile Apps</p>
              <div className="padT10">
                <a
                  target="_blank"
                  className="fthm-mobApp fthm-goog fl marginR5"
                  href="http://app.appsflyer.com/com.goibibo?pid=mobile_site&amp;c=m_header"
                ></a>
                <a
                  target="_blank"
                  className="fthm-mobApp fthm-app fl marginR5"
                  href="https://itunes.apple.com/in/app/goibibo-flight-bus-hotel-booking/id631927169?mt=8"
                ></a>
                <a
                  target="_blank"
                  className="fthm-mobApp fthm-windows fl"
                  href="http://www.windowsphone.com/en-in/store/app/goibibo/6f16a6ec-3b7e-4782-9f74-57f75a4cc1a3"
                ></a>
              </div>
            </div>
            <div className="col-md-5 col-sm-3 marginT5 pad0">
              <span className="commonSprite fl verifySign marginR10">&nbsp;</span>
              <span className="commonSprite fl americanExp marginT5 marginR10 ipaddn">&nbsp;</span>
              <span className="commonSprite fl masterCard marginT5 marginR10 ipaddn">&nbsp;</span>
              <span className="commonSprite fl visaCard marginT5 marginR10 ipaddn">&nbsp;</span>
              <span className="commonSprite payu marginT5 marginR10">&nbsp;</span>
              <span className="commonSprite rupay marginT2 marginR10 ipaddn">&nbsp;</span>
              <span className="commonSprite iata marginR10">&nbsp;</span>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-xs-12 footerCopyrights">
            <div className="col-md-8">
              <a
                rel="noopener"
                className="commonSprite mmt"
                target="_blank"
                href="https://www.makemytrip.com/"
              ></a>
              <span className="commonSprite backslash" href="#"></span>
              <a
                className="commonSprite redBus marginT5"
                target="_blank"
                href="http://www.redbus.in/"
              ></a>
              <a
                rel="nofollow"
                className="commonSprite ads"
                target="_blank"
                href="http://www.ibiboads.com/"
              ></a>
            </div>
            <div className="fr padT10">
              &copy;
              {' ' + new Date().getFullYear() + ' ibibogroup All rights reserved'}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
